exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-info[data-v-e3ae99ea]{display:grid;grid-template-columns:50% 50%;align-items:center}.media-info .media_info[data-v-e3ae99ea]{justify-content:flex-end}p.title[data-v-e3ae99ea]{max-height:48px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3ae99ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Track.vue
// module id = 53
// module chunks = 0